const $ = jQuery.noConflict();
import Global from '../shared/global';

'use strict';
const footer = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domFooterContainer: $('.js-footer-container'),
	$domFooterImgCol: $('.js-footer-img-col'),
	$domFooterImg: $('.js-footer-img'),
	$domFooterSub: $('.js-footer-sub-dropdown'),
	$domFooterSubArrow: $('.js-footer-sub-dropdown-icon'),

	/** @description Initialize */
	init: function() {
		this.appendItems();
		this.bindEvents();
	},

	bindEvents: function() {
		this.$domFooterSub.on('click', this.toggleDropdown);
		if ($(window).width() < 1200) {
			Global.$domBody.on('mouseup', function(e) {
				if (!footer.$domFooterSub.is(e.target) && footer.$domFooterSub.has(e.target).length === 0) {
					footer.closeDropdown();
				}
			});
		}
		if ($(window).width() > 1200) {
			this.$domFooterSub.on('mouseenter', this.addDropdown);
			this.$domFooterSub.on('mouseleave', this.closeDropdown);
		}
	},

	appendItems: function() {
		if ($(window).width() < 992) {
			this.$domFooterContainer.append(this.$domFooterImg);
		} else {
			this.$domFooterImgCol.append(this.$domFooterImg);
		}
		$(window).resize(function() {
			if ($(window).width() < 992) {
				footer.$domFooterContainer.append(footer.$domFooterImg);
			} else {
				footer.$domFooterImgCol.append(footer.$domFooterImg);
			}
		});
	},

	toggleDropdown: function() {
		$(this).toggleClass('active-hover');
	},

	addDropdown: function() {
		$(this).addClass('active-hover');
	},

	closeDropdown: function() {
		footer.$domFooterSub.removeClass('active-hover');
	},
};

export default footer;
